export default __webpack_public_path__ + "0cfa81cfe61f77c4656b39d026432f6d.png";